import BuyIntentionOffers from 'components/Modals/BuyIntentionOffers';
import * as BuyIntentionModels from 'model/BuyIntention';
import { useDispatch, useSelector } from 'react-redux';
import * as MyOrderIntentionEditSelectors from 'store/state/myOrderIntentionEdit/myOrderIntentionEditSelectors';
import { actions as MyOrderIntentionEditActions } from 'store/state/myOrderIntentionEdit/myOrderIntentionEditSlice';
import * as S from '../styles';
import EditIntentionItemFields from './EditIntentionItemFields';
import * as Item from './styles';
import { useEditIntentionItemActions } from './useEditIntentionItemActions';

interface Props {
  tableData?: BuyIntentionModels.BuyIntentionData[];
}

export default function EditIntentionItems({ tableData }: Props) {
  const dispatch = useDispatch();
  const actions = useEditIntentionItemActions();
  const isLoading = useSelector(MyOrderIntentionEditSelectors.getIsLoading);
  const showModalOffers = useSelector(
    MyOrderIntentionEditSelectors.getShowModalOffers,
  );
  const items = Array.isArray(tableData) ? tableData : [];

  return (
    <>
      <BuyIntentionOffers
        modalIsVisible={showModalOffers}
        setModalIsVisible={() =>
          dispatch(MyOrderIntentionEditActions.setShowModalOffers(false))
        }
      />

      <Item.List>
        {items.map((item) => (
          <Item.Section key={item.id} aria-label={item.productName}>
            <Item.Header>
              <Item.Title>{item.productName}</Item.Title>
              {item.site?.conceptName && (
                <Item.Concept>{item.site.conceptName}</Item.Concept>
              )}
              <Item.Secondary>
                {[
                  item.productCode,
                  item.site
                    ? `${item.site.account} - ${item.site.tradingName}`
                    : undefined,
                ]
                  .filter(Boolean)
                  .join(' · ')}
              </Item.Secondary>
            </Item.Header>
            <EditIntentionItemFields item={item} actions={actions} />
          </Item.Section>
        ))}
      </Item.List>

      {isLoading && (
        <S.Overlay>
          <S.Loader spinning={isLoading} size="large" />
        </S.Overlay>
      )}
    </>
  );
}
